import { render, staticRenderFns } from "./BaseDataForm.vue?vue&type=template&id=bc2ad32e"
import script from "./BaseDataForm.vue?vue&type=script&lang=ts"
export * from "./BaseDataForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports